export const toastConfig = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: 'light',
};

export const toastTypes = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
};

export const toastMessages = {
  // Auth messages
  LOGIN_SUCCESS: 'Login successful!',
  LOGIN_ERROR: 'Login failed. Please check your credentials.',
  LOGOUT_SUCCESS: 'Log out successfully!',
  LOGOUT_ERROR: 'Logout failed. Please try again.',
  
  // General messages
  SAVE_SUCCESS: 'Changes saved successfully!',
  SAVE_ERROR: 'Failed to save changes.',
  DELETE_SUCCESS: 'Deleted successfully!',
  DELETE_ERROR: 'Failed to delete.',
  UPDATE_SUCCESS: 'Updated successfully!',
  UPDATE_ERROR: 'Failed to update.',
  
  // User Management messages
  USER_CREATED: 'User created successfully!',
  USER_UPDATED: 'User updated successfully!',
  USER_DELETED: 'User deleted successfully!',
  USER_CREATE_ERROR: 'Failed to create user.',
  USER_UPDATE_ERROR: 'Failed to update user.',
  USER_DELETE_ERROR: 'Failed to delete user.',
  DUPLICATE_EMAIL: 'Email address already exists.',
  
  // Network messages
  NETWORK_ERROR: 'Network error. Please check your connection.',
  SERVER_ERROR: 'Server error. Please try again later.',
  
  // Validation messages
  VALIDATION_ERROR: 'Please fill in all required fields.',
  INVALID_INPUT: 'Invalid input. Please check your data.',
};
